<template>
  <a class="pointer delete" @click="click" v-c-tooltip.hover.click="'Delete'">
    <CIcon name="cil-trash" />
  </a>
</template>
<script>
export default {
  prop: [],
  methods: {
    click() {
      const conf = confirm("Yakin akan menghapus item ?");
      if (conf) {
        this.$emit("click");
      }
    },
  },
};
</script>